import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { BackRow } from "./shared";
import { Field } from "./BookingForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Contact info is required before the Business Scaling Assessment.
export function AssessmentContactScreen({ content, submissionId, teamSize, source = "diag", onReady, onBack }) {
  const A = content.assessment_handoff;
  const [form, setForm] = useState({ name: "", business_name: "", email: "", phone: "", consent_to_contact: false });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setForm({ ...form, [k]: v });

  const submit = async () => {
    if (!form.name.trim() || !form.email.includes("@") || form.phone.replace(/\D/g, "").length < 7) {
      return toast.error("Please add your name, email, and phone so Jonathan can follow up.");
    }
    if (!form.consent_to_contact) return toast.error("Please check the contact box so Jonathan can follow up.");
    setBusy(true);
    try {
      const r = await fetch(`${API}/next-move/assessment-leads`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, submission_id: submissionId || null, team_size: teamSize || null, source }),
      });
      if (!r.ok) throw new Error(await r.text());
      onReady((await r.json()).token);
    } catch (e) {
      toast.error("Something went wrong — please try again in a moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-7 md:p-10" data-testid="nm-assessment-screen">
      {onBack && <BackRow onBack={onBack} progress="Business Scaling Assessment" />}
      <h2 className="font-heading text-2xl md:text-3xl text-cvc-navy leading-snug">{A.title}</h2>
      <p className="font-body text-cvc-ink-soft mt-3 text-sm leading-relaxed">{A.body}</p>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Your name" value={form.name} onChange={set("name")} testId="nm-assess-name" />
        <Field label="Business name (optional)" value={form.business_name} onChange={set("business_name")} testId="nm-assess-business" />
        <Field label="Email" value={form.email} onChange={set("email")} testId="nm-assess-email" type="email" />
        <Field label="Phone" value={form.phone} onChange={set("phone")} testId="nm-assess-phone" type="tel" />
      </div>
      <div className="mt-5 flex items-start gap-3">
        <Checkbox id="nm-assess-consent" data-testid="nm-assess-consent" checked={form.consent_to_contact}
          onCheckedChange={(v) => setForm({ ...form, consent_to_contact: !!v })} className="mt-1" />
        <Label htmlFor="nm-assess-consent" className="font-body text-sm text-cvc-ink leading-snug">{A.consent}</Label>
      </div>
      <div className="mt-6">
        <Button data-testid="nm-assess-submit" onClick={submit} disabled={busy}
          className="bg-cvc-red hover:bg-cvc-red-deep text-white rounded-full px-7 py-5 h-auto font-body disabled:opacity-60">
          {busy ? "Saving..." : A.submit_label}
        </Button>
      </div>
    </div>
  );
}
